import React from 'react';
import { Spin } from 'antd';

const FullPageLoader = ({ isSpinning }: { isSpinning: boolean }) => {
  if (!isSpinning) return null;
  return <Spin spinning fullscreen />;
};

export default FullPageLoader;
